import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

import App from './App.vue';
import router from './router';
import store from './store';

Vue.use(VueAxios, axios);

Vue.config.productionTip = false;

Vue.filter('formatTimestamp', function (timestamp: number)  {
    const monthName = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const date = new Date(timestamp * 1000);
    const day = date.getDate();
    let dayStr = "";
    switch (day) {
        case 1: dayStr = "1st"; break;
        case 2: dayStr = "2nd"; break;
        case 3: dayStr = "3rd"; break;
        default: dayStr = day + "th"; break;
    }
    const month = date.getMonth();
    const year = date.getFullYear();
    let yearStr = year.toString();
    if (year === (new Date()).getFullYear())
    yearStr = "";
    return `${monthName[month]} ${dayStr} ${year}`;
});

Vue.filter('capitalize', function (value: string) {
    if (!value)
        return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
});

new Vue({
    router, 
    store,
    render: (h) => h(App),
}).$mount('#app');
